"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDiacritics = exports.fixDiacritics = void 0;
var const_1 = require("../../const");
function fixDiacritics(text) {
    return (text
        // cleans zwnj before diacritic characters
        .replace(new RegExp("\u200c([" + const_1.persianDiacritic + "])", "g"), "$1")
        // cleans more than one diacritic characters
        .replace(new RegExp("(.*)([" + const_1.persianDiacritic + "]){2,}(.*)", "g"), "$1$2$3")
        // cleans spaces before diacritic characters
        .replace(new RegExp("(\\S)[ ]+([" + const_1.persianDiacritic + "])", "g"), "$1$2"));
}
exports.fixDiacritics = fixDiacritics;
function removeDiacritics(text) {
    return (text
        // removes all diacritic characters
        .replace(new RegExp("[" + const_1.persianDiacritic + "]+", "g"), ""));
}
exports.removeDiacritics = removeDiacritics;
